import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceProviderService {

  deviceApp: string;
  idUsuario: number;
  usuario: string;
  pass: string;
  token: string;
  isWeb: boolean = false;

  constructor() {}

  setData(
    deviceApp: string,
    idUsuario: number,
    usuario: string,
    pass: string,
    token: string
  ) {
    this.deviceApp = deviceApp;
    this.idUsuario = idUsuario;
    this.usuario = usuario;
    this.pass = pass;
    this.token = token;
  }

  setDevice(deviceApp) {
    this.deviceApp = deviceApp;
  }

  getDevice(){
    return this.deviceApp;
  }

  setIdUsuario(idusuario) {
    this.idUsuario = idusuario;
  }

  getIdUsuario(){
    return this.idUsuario;
  }

  setUsuario(usuario){
    this.usuario = usuario;
  }

  getUsuario(){
    return this.usuario;
  }

  setPass(pass){
    this.pass = pass;
  }

  getPass(){
    return this.pass;
  }

  setToken(token){
    this.token = token;
  }

  getToken() {
    return this.token;
  }
  setIsWeb(isWeb: boolean){
    this.isWeb = isWeb;
  }
  getIsWeb(){
    return this.isWeb;
  }
}
